
import { listApplications, deleteApplication as deleteOrgAPI, createApplication, fetchApplications, updateApplication } from '../services/application_service';

const useApplications = (applicationId = null) => {
    const [applicationsData, setApplicationsData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);


    const [initialValues, setInitialValues] = useState({
        app_name: "",
        description: "",
        application_icon: null
    });

    const fetchApplicationsData = async (applicationId) => {
        try {
            const applications = await listApplications(applicationId);
            const app_data = applications.data;
            app_data.forEach((application, index) => {
                application.serial = index + 1;
            });
            setApplicationsData(app_data);
            setIsLoading(false);
        } catch (error) {
            setError(error.message);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchApplicationsData();
    }, [applicationId]);

    const fetchApplication = useCallback(async (applicationId) => {
        try {
            const res = await listApplications(applicationId);
            const app_data = res.data;
            setInitialValues({
                app_name: app_data.app_name || "",
                description: app_data.description || "",
                application_icon: app_data.application_icon || "",
            });
            return app_data;
        } catch (error) {
            toast.error("Failed to fetch application details");
        }
    }, [applicationId]);


    const deleteApplication = async (id) => {
        try {
            await deleteOrgAPI(id);
            setApplicationsData(applicationsData.filter(item => item.id !== id));
        } catch (error) {
            setError(error.message);
        }
    };


    const createOrUpdateApp = async (id, values) => {
        try {
            let response = '';
            if (!id) {
                response = await createApplication(values);
                toast.success('Application created successfully');
                fetchApplicationsData();
            } else {
                response = await updateApplication(id, values);
                toast.success('Application updated successfully');
                // fetchApplicationsData();
                setApplicationsData(applicationsData.map((app) =>
                    app.id === id ? response.data : app
                ));


            }
        } catch (error) {
            console.error('Error submitting form:', error);
            let errorMessage = 'Failed to update application. Please try again.';
            if (error.response && error.response.data && error.response.data.message) {
                errorMessage = error.response.data.message;
            }
            toast.error(`Failed to update application. Please try again. ${errorMessage}`, toastOptions);
        }
    }
    return {
        applicationsData, setApplicationsData, isLoading, error, deleteApplication, fetchApplicationsData, initialValues, setInitialValues, fetchApplication, createOrUpdateApp
    };
};

export default useApplications;
